import { Guid } from "guid-typescript";
import { PlacementStudentV2 } from "../tutor-reports/tutorreport";

export class PlacementMaintenance {
    placementInfo: PlacementInformation;
    sessionSummaryInformation: SessionSummary;
    placementStudents: PlacementStudentV2[];
    lessonPlanTypes: LessonPlanType[];
    provisionTypes: ProvisionType[];
    lockGroupInformation: boolean;
    maxStudentNumber: number;
    lockReferrer: boolean;
    lockBrambleSwitch: boolean;
    allowStudentDateChanges: boolean;
    dotFlag: number;
    lockEdPlaceSwitch: boolean;
    lockSubjectSwitch: boolean;
    lockPlacementTypeSelector: boolean;
    lockCustodian: boolean;
    createClientUserAccounts: boolean;
    showCreateClientAccount: boolean;
    hideGroupSwitch: boolean;
    allowProvisionTypeEdit: boolean;
    riskAssessmentNotes?: string;


    constructor() {
        this.sessionSummaryInformation = new SessionSummary();
    }
}

export class SessionSummary {
    nextSession: string;
    remainingSessions: number;
    savedSessions: number;
    submittedSessions: number;
    approvedSessions: number;
    rejectedSessions: number;
    /** Slots Orbit holds as Cancelled with no settled report — their own bucket, not folded into submitted. */
    cancelledSessions: number;

    constructor() {
        this.nextSession = 'n/a';
        this.remainingSessions = 0;
        this.savedSessions = 0;
        this.submittedSessions = 0;
        this.approvedSessions = 0;
        this.rejectedSessions = 0;
        this.cancelledSessions = 0;
    }
}

export class PlacementInformation {
    placementId: string;
    clientId: number;
    clientName: string;
    subject: string;
    yearGroup: string;
    startDate: Date;
    endDate: Date;
    placementType: string;
    brambleEnabled: boolean;
    edPlaceEnabled: boolean;
    currentGroupName: string;
    isGroup: boolean;
    groupSize: number;
    placementReferrer: number;
    placementReferrerName: string;
    placementCustodian: number;
    lessonPlanTypeCode: string;
    lessonPlanTypeCodeDefault: string;
    informationLocked: boolean;
    lockSubject: boolean;
    studentsSwappable: boolean;
    studentsSwappableDefault: boolean;
    studentCommentsOptional: boolean;
    studentCommentsOptionalDefault: boolean;
    systemSubject: string;
    insertedDate: Date;
    insertedUser: number;
    updatedDate?: Date;
    updatedUser?: number;
    digitalClassroomId: Guid;
    digitalClassroomEnabled: boolean;
    // Orbit OPC DeliveryMode ('Online'/'In person') - raw string, compare case-insensitively.
    deliveryMode: string;
    provisionTypeCode: string;

    constructor() {
        this.placementId = "0";
        this.clientId = 0;
        this.clientName = "";
        this.subject = "";
        this.yearGroup = "";
        this.startDate = null;
        this.endDate = null;
        this.placementType = "";
        this.brambleEnabled = false;
        this.edPlaceEnabled = false;
        this.currentGroupName = "";
        this.isGroup = false;
        this.groupSize = 0;
        this.placementReferrer = 0;
        this.placementReferrerName = "";
        this.placementCustodian = 0;
        this.informationLocked = false;
        this.lockSubject = false;
        this.insertedDate = null;
        this.insertedUser = 0;
        this.updatedDate = null;
        this.updatedUser = null;
        this.lessonPlanTypeCode = "";
        this.digitalClassroomId = null;
        this.digitalClassroomEnabled = false;
        this.deliveryMode = null;
        this.provisionTypeCode = "";
    }
}

export class LessonPlanType {
    code: string;
    displayName: string;

    constructor() {}
}

export class GroupStudentSessionDateGap {
    studentId: number;
    startDate: Date;
    endDate: Date;
}

export class ProvisionType {
    provisionTypeCode: string;
    provisionTypeName: string;
}

